import * as Braze from '@braze/web-sdk';

export const changeUser = (userId: string, signature?: string) => {
  Braze.changeUser(userId, signature);
  Braze.openSession();
};

export const initializeBraze: typeof Braze.initialize = (apiKey, options) => {
  const initResult = Braze.initialize(apiKey, options);
  Braze.automaticallyShowInAppMessages();
  Braze.openSession();

  return initResult;
};
export const openBrazeSession = Braze.openSession;
export const destroyBraze = Braze.destroy;
export const wipeBrazeData = Braze.wipeData;
export const setLanguage = (language: string | null) => {
  Braze.getUser()?.setLanguage(language);
};
export const setFirstName = (name: string) => {
  Braze.getUser()?.setFirstName(name);
};
export const setPhoneNumber = (number: string) => {
  Braze.getUser()?.setPhoneNumber(number);
};
export const setEmail = (email: string) => {
  Braze.getUser()?.setEmail(email);
};

export const setCustomUserAttribute = (
  key: string,
  value: string | number | boolean | object | Date | null
) => {
  Braze.getUser()?.setCustomUserAttribute(key, value);
};

export const logCustomEvent = Braze.logCustomEvent;
export const logPurchase = Braze.logPurchase;

export const requestImmediateDataFlush = Braze.requestImmediateDataFlush;
export const enableBrazeSdk = Braze.enableSDK;
export const disableBrazeSdk = Braze.disableSDK;
